import { MappableModel } from './mappable-model'

export class ClareSaleGroup  extends MappableModel {
  public id: string
  public sale_group_number: number
}
